var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.291,
    height: 36.291,
    viewBox: "0 0 36.291 36.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "like",
    transform: "translate(-4393.675 -2167.377)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 18.145,
    cy: 18.145,
    r: 18.145,
    transform: "translate(4393.675 2167.377)",
    fill: "#5181f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 4.73,
    height: 10.642,
    transform: "translate(4401.654 2182.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M4420.42,2184.118a1.658,1.658,0,0,0-.881-3.066h-5.093a27.786,27.786,0,0,0-.08-4.4c-.3-2.66-3.1-1.478-3.1-1.478,1.479,3.252-3.1,9.016-3.1,9.016v8.61h9.481a8.145,8.145,0,0,1,2.612-4.471,1.656,1.656,0,0,1,.95-2.808A1.659,1.659,0,0,0,4420.42,2184.118Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.8bb089ecc80d9958d799f1b45679ed04.svg";
export { ForwardRef as ReactComponent };